<div [ngSwitch]="format" [class.opacity-65]="control.disabled === true">

    <div *ngSwitchCase="'currency'" class="slider-selection-vals">Entre&nbsp;
        <span class="dark-blue font-weight-bold text-primary">{{control.value[0] | currencyLocal}}</span>&nbsp;y&nbsp;
        <span class="dark-blue font-weight-bold text-primary">{{control.value[1] | currencyLocal}}{{secondaryMaxText}}</span>&nbsp;{{titleValues}}
    </div>

    <div *ngSwitchDefault class="slider-selection-vals">
        {{control.value[0] === control.value[1] - 1 ? 'Más de ' : 'Entre'}}
        <span *ngIf="control.value[0] !== control.value[1] - 1 " class="dark-blue font-weight-bold text-primary">{{control.value[0]}}&nbsp;y&nbsp;</span>
        <span class="dark-blue font-weight-bold text-primary">{{control.value[1]- 1}}{{control.value[0] !== control.value[1] - 1  && control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{titleValues}}
    </div>
</div>

<div class="my-uislider mgn-bottom-15">

    <nouislider #nouislidernolinear (change)="onChangeValuesSlider()" (slide)="eventUpdate($event)" [config]="rangeConfig" [connect]="[false,true,false]"
        [formControl]="control"></nouislider>

</div>